import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { Chip, DialogActions, Grid } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import { getBestTextColorFromHex } from 'lib/functions/utils';
import KeyValueRow from 'lib/designSystem/KeyValueRow';
import DeleteTag from '../DeleteTag';
import EditTag from '../EditTag';

const TagSummary = (props: any) => {
  const { open, onClose, tag, setUp, category } = props;
  const [openDeleteTag, setOpenDeleteTag] = useState(false);
  const [openEditTag, setOpenEditTag] = useState(false);

  const handleEditTag = () => {
    setOpenEditTag(true);
  };

  const handleDeleteTag = () => {
    setOpenDeleteTag(true);
  };

  return (
    <div>
      <Dialog open={open} maxWidth="sm" fullWidth >
        <DialogTitle>Tag</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            <KeyValueRow label="Nombre" value={tag.name} />
            <KeyValueRow label="Descripción" value={tag.description} />
            <Grid container spacing={2}>
              <Grid item xs={8} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontWeight={600}>Color:</Typography>
              </Grid>
              <Grid item xs={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <Chip
                  label={tag.color}
                  sx={{ backgroundColor: tag.color, color: getBestTextColorFromHex(tag.color), fontWeight: 600 }}
                  style={{ width: 'fit-content' }}
                />
              </Grid>
            </Grid>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Chip
                label={tag.name}
                sx={{ backgroundColor: tag.color, color: getBestTextColorFromHex(tag.color), fontWeight: 600 }}
                style={{ width: 'fit-content' }}
              />
            </div>
          </div>
        </DialogContent >
        <DialogActions>
          <CustomButton
            onClick={onClose}
            color="secondary"
          >
            Salir
          </CustomButton>
          <CustomButton
            onClick={handleDeleteTag}
            color="error"
          >
            Eliminar
          </CustomButton>
          <CustomButton
            onClick={handleEditTag}
            color="primary"
          >
            Editar
          </CustomButton>
        </DialogActions>
      </Dialog>
      {openDeleteTag && (
        <DeleteTag
          open={openDeleteTag}
          onClose={() => setOpenDeleteTag(false)}
          tag={tag}
          setUp={setUp}
          category={category}
        />
      )}
      {openEditTag && (
        <EditTag
          open={openEditTag}
          onClose={() => setOpenEditTag(false)}
          tag={tag}
          setUp={setUp}
          category={category}
        />
      )}
    </div>
  );
};

export default TagSummary;